export const hexToRgb = (hex: string) => {
  if (hex.startsWith('#')) {
    return hex
      .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
      .substring(1)
      .match(/.{2}/g)
      ?.map((x) => Number.parseInt(x, 16));
  }

  return null;
};
